<div class="th-page">

    <!-- ── Page header ───────────────────────────────── -->
    <div class="th-header">
        <div class="th-header-left">
            <h2 class="th-title">Transaction history</h2>
            <span class="th-count">{{ totalRecords() }} records</span>
        </div>
        <div class="th-header-actions">
            <button class="th-btn" type="button" disabled>
                <i class="fa-solid fa-arrow-up-from-bracket"></i> Export
            </button>
        </div>
    </div>

    <!-- ── Tabs ──────────────────────────────────────── -->
    <div class="th-tabs">
        <button class="th-tab" [class.th-tab--active]="activeTab === 0" (click)="activeTab = 0" type="button">
            Payment History
        </button>
        <button class="th-tab" [class.th-tab--active]="activeTab === 1" (click)="activeTab = 1" type="button">
            Wallet History
        </button>
    </div>

    <!-- ── Tab content ───────────────────────────────── -->
    <div class="th-card">
        <div [hidden]="activeTab !== 0">
            <app-table-component
                [data]="paymentTransactionHistoryList()"
                [columns]="tableColumns"
                [totalRecords]="totalRecords()"
                [rows]="rows"
                [first]="first"
                (pageChange)="onPageChange($event)"
                [showColumnSelector]="false"
                [showClearFilters]="false"
                [searchControl]="searchControl"
                [customFilters]="[operationTypeFilter, displayStatusFilter, createdDateFilter]" />
        </div>
        <div [hidden]="activeTab !== 1">
            <app-wallet-history-list />
        </div>
    </div>

</div>
